export const AIRTABLE_APPLICATION_URL =
    'https://airtable.com/app1tUDBjiKR4efbT/pagPE3sROmYicBbxJ/form';
